import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '/styles/simpleSlider.module.scss';
import BtnSlider from './btnSlider';

const SimpleSlider = ({ dataSlider }) => {
    const { i18n } = useTranslation('configuration');
    const [slideindex, setSliderIndex] = useState(1)
    const [touchStart, setTouchStart] =  useState(0)
    const [touchEnd, setTouchEnd] =  useState(0)

    const nextSlider = () => {
        const nextSlideIndex = slideindex !== dataSlider.length ? slideindex : 0;
        setSliderIndex(nextSlideIndex + 1);
    }

    const prevSlider = () => {
        const prevSlideIndex = slideindex !== 1 ? slideindex - 1 : dataSlider.length;
        setSliderIndex(prevSlideIndex);
    }

    const moveDot = index => {
        setSliderIndex(index)
    }

    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    }
    
    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    }
    
    const handleTouchEnd = () => {
        if (touchStart - touchEnd > 50) {
            nextSlider();
        }
    
        if (touchStart - touchEnd < -50) {
            prevSlider();
        }
    }

    return (
        <div className={styles.containerSlider}>
            {dataSlider.map((data, index) => {
                return (
                    <div key={index} className={slideindex === index + 1 ? `${styles.slide} ${styles['active-anim']}` : `${styles.high}`}>
                        <div
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                            onTouchMove={handleTouchMove}
                        >
                            {data}
                        </div> 
                    </div>
                )
            })}
            <BtnSlider moveSlider={nextSlider} direction={'next'} />
            <BtnSlider moveSlider={prevSlider} direction={'prev'} />
            <div className={styles['contaiter-dots']}>
                {Array.from({ length: 2 }).map((item, index) => (
                    <div className={`${styles.dot} ${slideindex === index + 1 ? styles.active : ''}`}
                        onClick={() => moveDot(index + 1)}
                        key={index}
                    >
                    </div>
                ))}
            </div>
        </div>
    )
};

export default SimpleSlider;
